define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/when",
	"csi/_base/underscore",
	"csi/store/Nodes",
	"csi/store/_ClientRequestMixin",
	"csi/xml",
	"csi/resolver",
	"csi/table/Widget",
	"Apparel/ProductType"
], function(declare,lang,when,_,Nodes,_ClientRequestMixin,xml,resolver,Widget,ProductType) {

	var WBS_TEMPLATES = "WBSTemplates";

	var _Store = declare([Nodes,_ClientRequestMixin], {
		bSimpleQueryEngine: true,

		_resolveData: function(/*Deferred*/dfd) {
			// query the defaults for the selected season
			var queryResult = ProductType.store("StyleType").query();

			when(queryResult, function(allStyleTypes) {
				var data = _.map(allStyleTypes, function(st) {
					var node = xml.nodeCreateClientNode(null, "StructureItemDefaults", st.Name + "_Map", xml.NODE_FLAG_NOEDIT);
					xml.nodeCreateClientAttr(node, "StyleType",   xml.ATTR_STRING, st.Name);
					return node;
				});

				dfd.resolve(data);
			});
		}
	});


	var widget = declare([Widget], {
        _createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			// summary: convert table entries into fake nodes
			var	ql = this.inherited(arguments);
            if (ql.bMain) {
                ql.createCustomStore = lang.hitch(this, function(ctx, bConfigurable) {
                	if (!bConfigurable) {
            			var defaults     = this.getViewNode();
            			var WBSTemplates = defaults.WBSTemplates;

                		return new _Store({
                			WBSTemplates: WBSTemplates,
                			cachingStore: this.cacheView
                		});
                	}
                });
            }
			return ql;
		}
	});


	return widget;
});